module.exports = __webpack_public_path__ + "static/img/bg_11.65c219f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_11.jpg
// module id = dMdC
// module chunks = 1